<div class="d-flex flex-column gap-3">
    <div ngbAccordion *ngFor="let faq of renderedFrequentlyAskedQuestions; let last = last" 
        [ngClass]="{'mb-1':!last}">
        <div ngbAccordionItem>
            <h2 ngbAccordionHeader>
                <button ngbAccordionButton>
                    {{faq.question}}
                </button> 
            </h2>
            <div ngbAccordionCollapse>
                <div ngbAccordionBody>
                    <div [innerHTML]="faq.answer" class="overflow-auto">
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>